import Component from '../abstracts/Component';
import vex from 'vex-js';
import TrackingComponent from '../components/TrackingComponent';
import {isBreakpoint, isMobile, MobileBreakpoint} from '../utils/MobileUtils';

export default class AddToCartComponent extends Component {

  options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  }

  constructor(compEl) {
    super(compEl);
    this.desktopAddToCartElement = this.$component.hasAttribute(this.SELECTORS.desktopAddToCartElement) ? this.$component : null;
    this.desktopSelectSizeBtn = this.desktopAddToCartElement?.querySelector(this.SELECTORS.fixedSelectSizeBtn);
    this.fixedAddToCartElement = document.querySelector(this.SELECTORS.fixedAddToCartElement);
    this.fixedCtaInnerElement = this.fixedAddToCartElement?.querySelector(this.SELECTORS.fixedCtaInnerElement);
    this.fixedSelectSizeBtn = this.fixedAddToCartElement?.querySelector(this.SELECTORS.fixedSelectSizeBtn);
    this.notifyMe = document.querySelector(this.SELECTORS.notifyMe);
    this.notifyMeBtn = document.querySelector(this.SELECTORS.notifyMeBtn);
    this.notifyMeBtnFixed = document.querySelector(this.SELECTORS.notifyMeBtnFixed);
    this.notifyMeLayer = this.fixedAddToCartElement?.querySelector(this.SELECTORS.notifyMeLayer);
    this.notifyMeLayerCloseBtn = this.notifyMeLayer?.querySelector(this.SELECTORS.notifyMeLayerCloseBtn);
    this.notifyMeBackdrop = this.fixedAddToCartElement?.querySelector(this.SELECTORS.notifyMeBackdrop);
    this.selectSizeBackdrop = this.fixedAddToCartElement?.querySelector(this.SELECTORS.selectSizeBackdrop);
    this.notifyMeMobile = this.fixedAddToCartElement?.querySelector(this.SELECTORS.notifyMeMobile);
    this.selectSizeLayer = this.fixedAddToCartElement?.querySelector(this.SELECTORS.selectSizeLayer);
    this.selectSizeLayerCloseBtnList = this.fixedAddToCartElement?.querySelectorAll(this.SELECTORS.selectSizeLayerCloseBtn);
    this.notifyCloseBtn = this.$component?.querySelector(this.SELECTORS.notifyMeCloseBtn);
    this.recommendationEngineElement = document.querySelector(this.SELECTORS.recommendationEngineElement);
    this.sizes = this.$component.querySelectorAll(this.SELECTORS.sizes);
    this.footerElement = document.querySelector(this.SELECTORS.footerElement);
    this.itemAdded = this.fixedAddToCartElement?.querySelector(this.SELECTORS.itemAdded);
    this.itemAddedSize = this.itemAdded?.querySelector(this.SELECTORS.itemAddedSize);
    this.itemAddedSlot = this.fixedAddToCartElement?.querySelector(this.SELECTORS.itemAddedSlot);
    this.errorsBox = this.$component.querySelector(this.SELECTORS.errorsBox);
    this.TrackingComponent = new TrackingComponent();
    this.isQuickshop = this.$component.hasAttribute(this.SELECTORS.isQuickshop) ? this.$component : null;
    this.cleanup = null;
    this.productCode = this.$component.dataset.productCode;

    // Low stock popup variables
    this.lowStockModalInstance = null;
    this.modalFormSubmitHandler = null;

    this.prices = this.$component.querySelector(this.SELECTORS.prices);
    this.infoWrapper = this.$component.querySelector(this.SELECTORS.infoWrapper);
    this.actions = this.$component.querySelector(this.SELECTORS.actions);

    // Verify if is unique size (desktop button)
    this.productIsUniqueSize =
      this.desktopSelectSizeBtn?.hasAttribute(this.SELECTORS.uniqueSizeDataAttribute) &&
      this.desktopSelectSizeBtn?.getAttribute(this.SELECTORS.uniqueSizeDataAttribute) === 'true';

    // Verify if is unique size (fixed mobile button)
    this.productIsUniqueSizeFixed =
      this.fixedSelectSizeBtn?.hasAttribute(this.SELECTORS.uniqueSizeDataAttribute) &&
      this.fixedSelectSizeBtn?.getAttribute(this.SELECTORS.uniqueSizeDataAttribute) === 'true';
  }

  get COMPONENTNAME() {
    return 'AddToCartComponent';
  }

  get SELECTORS() {
    return {
      desktopAddToCartElement: 'data-pdp-cta',
      fixedAddToCartElement: '[data-pdp-fixed-cta]',
      fixedCtaInnerElement: '[data-cta-inner]',
      fixedSelectSizeBtn: '[data-size-selection]',
      addToCartBtn: '[data-js-add-to-cart]',
      queryId: '[data-algolia-query-id]',
      authenticatedUserToken: '[data-authenticated-user-token]',
      searchIndex: '[data-search-index]',

      notifyMe: '[data-notify-me]',
      notifyMeBtn: '[data-notify-me-btn]',
      notifyMeBtnFixed: '[data-notify-me-fixed]',
      notifyMeMobile: '[data-floating-bar="true"]',

      selectSizeBackdrop: '[data-sizes-backdrop]',
      selectSizeLayer: '[data-sizes-layer]',
      selectSizeLayerCloseBtn: '[data-sizes-layer-close]',
      sizes: '[data-size] input[type="radio"]',
      footerElement: 'footer',
      itemAdded: '[data-pdp-item-added]',
      itemAddedClose: '[data-pdp-item-close]',
      itemAddedSize: '[data-add-to-cart-size]',
      itemAddedSlot: '[data-product-added-slot]',
      isQuickshop: 'data-is-quickshop',
      errorsBox: '[data-errors-box]',
      lowStockShowNotifyMeForm: '[data-show-notify-me-form]',
      lowStockPopupActions: '[data-lowstock-popup-actions]',
      lowStockPopupNotifyMeForm: '[data-lowstock-popup-notify-me-form]',
      lowStockPopupNotifyMeError: '[data-lowstock-popup-notify-me-error]',
      lowStockPopupNotifyMeSubmit: '[data-lowstock-popup-notify-me-submit]',
      lowStockPopupNotifyMeInput: '[data-lowstock-popup-notify-me-input]',
      lowStockPopupNotifyMeSuccessWrapper:
        '[data-lowstock-popup-notify-me-success-wrapper]',
      lowStockPopupNotifyMeSuccessText:
        '[data-lowstock-popup-notify-me-success-text]',
      infoWrapper: '.js-info-wrapper',
      prices: '.js-prices',
      actions: '.js-actions',
      recommendationEngineElement: '[data-recommendation-engine-wrapper]',
      uniqueSizeDataAttribute: 'data-unique-size',
    };
  }

  get CLASSES() {
    return {
      added: 'added',
      hidden: '--hidden',
      disabled: '--disabled',
      show: 'show',
      addToCart: 'js-add-to-cart',
      sizeSelection: 'size-selection',
      success: 'success',
      text: 'text',
      zoom: 'zoom',
      loading: '--loading',
      inputError: 'error',
      selected: '--selected',
      icon: 'icon-cart',
      pointerEventNone: '--pointer-events-none'
    };
  }

  /**
   * Adds a product to the shopping cart with the specified size code.
   * Handles various scenarios including cart quantity limits, low stock, and success notifications.
   * Integrates with Algolia search tracking when query parameters are present.
   *
   * @param {string} sizeCode - The size code of the product to add to cart
   * @param {string} exceededQtyUrl - URL to use when cart quantity limit is exceeded
   * @param {string} lowStockUrl - URL to use when product stock is low
   * @param {boolean} showNotification - Flag to determine whether to show success notification
   * @param {HTMLElement} addToCartBtn - The add to cart button element containing data attributes
   *
   * @fires PRODUCT_EVENTS.sizerequired - When no size code is provided
   * @fires PRODUCT_EVENTS.addedtocart - When product is successfully added to cart
   * @fires BACKDROP_EVENTS.show - When showing mobile notification modal
   * @fires BACKDROP_EVENTS.hide - When hiding mobile notification modal
   * @fires SIZES_EVENTS.disableAll - When disabling all size options
   * @fires SIZES_EVENTS.enableAll - When enabling all size options
   *
   * @returns {void}
   */
  addToCart(sizeCode, exceededQtyUrl, lowStockUrl, showNotification, addToCartBtn) {
    const queryId = document.querySelector(this.SELECTORS.queryId)?.dataset?.algoliaQueryId;
    let finalUrl = addToCartBtn.dataset.href + '?code=' + sizeCode;

    if (queryId && queryId !== '') {
      let authenticatedUserToken = document.querySelector(this.SELECTORS.authenticatedUserToken)?.dataset?.authenticatedUserToken;
      let userToken = document.querySelector('[data-user-token]')?.dataset?.userToken;
      let indexName = document.querySelector(this.SELECTORS.searchIndex)?.dataset?.searchIndex;
      finalUrl = addToCartBtn.dataset.href + '?code=' + sizeCode + '&queryId=' + queryId + '&authenticatedUserToken=' + authenticatedUserToken + '&userToken=' + userToken + '&indexName=' + indexName;
    }

    if (!sizeCode) {
      this.$emit(this.$customEvents.PRODUCT_EVENTS.sizerequired, this.desktopSelectSizeBtn);
    } else {
      this.setLoadingState();

      fetch(finalUrl, { method: 'POST' }).then(res => {
        if (res.ok) {
          res.text().then(text => {
            //unset loading state
            this.unsetLoadingState();
            this.TrackingComponent.actions.addToCart(sizeCode);
            if (text == 650) {
              // show exceeded cart quantity modal
              const url = exceededQtyUrl + sizeCode;
              this.openModal(url, '--product-exceeded-modal');
            } else if (text == 651) {
              // show low stock modal
              const url = lowStockUrl + sizeCode;
              this.openModal(url, '--product-lowstock-modal');
            } else {
              // if no error occurs then emit event
              this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtocart, {
                productCode: sizeCode,
                baseProductCode: this.productCode
              });
              if (showNotification) {
                // show notification on mobile and desktop
                this.fixedCtaInnerElement?.classList.add(this.CLASSES.added);
                setTimeout(() => {
                  this.fixedCtaInnerElement?.classList.remove(this.CLASSES.added);
                }, 3000);
                if (isMobile(MobileBreakpoint.Max767)) {
                  if (!this.fixedAddToCartElement.classList.contains(this.CLASSES.show)) {
                    this.fixedAddToCartElement.classList.add(this.CLASSES.show);
                  }
                  const itemAdded = document.querySelector(`[data-pdp-item-added="${this.productCode}"]`);
                  // show notification on mobile
                  if (itemAdded) {
                    const itemAddedShadow = itemAdded;
                    this.itemAddedSlot.innerHTML = itemAddedShadow.outerHTML;
                    itemAddedShadow.classList.add(this.CLASSES.show);
                    // itemAddedShadow.classList.remove(this.CLASSES.hidden);
                    this.$emit(this.$customEvents.BACKDROP_EVENTS.show);
                    const itemAddedClose = this.itemAddedSlot.querySelector(this.SELECTORS.itemAddedClose);

                    itemAddedClose?.addEventListener('click', () => {
                      itemAddedShadow.classList.remove(this.CLASSES.show);
                      itemAddedShadow.classList.add(this.CLASSES.hidden);
                      this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
                      this.cleanup && this.cleanup();
                      this.cleanupNotifyMe && this.cleanupNotifyMe();
                      (this.desktopAddToCartElement && !this.isQuickshop) ? this.startAddToCartObserver() : null;
                      this.cleanupNotifyMe = (this.notifyMeBtn && !this.isQuickshop) ? this.startNotifyMeObserver() : null;

                      this.itemAddedSlot.classList.remove(this.CLASSES.show);
                      this.itemAddedSlot.querySelector(this.SELECTORS.itemAdded).classList.add(this.CLASSES.hidden);
                    });

                    this.itemAddedSlot.classList.add(this.CLASSES.show);
                    this.itemAddedSlot.querySelector(this.SELECTORS.itemAdded).classList.remove(this.CLASSES.hidden);
                  }
                }
              }
              // show success state on buttons
              this.isQuickshop ? null : this.fixedSelectSizeBtn?.classList.add(this.CLASSES.success);
              if (this.desktopSelectSizeBtn) {
                this.desktopSelectSizeBtn.classList.add(this.CLASSES.success);
              }
              // if not uniquesize product, disable all sizes until animation is finished
              if (!this.productIsUniqueSize) {
                this.$emit(this.$customEvents.SIZES_EVENTS.disableAll);
              }
              // pointer event rule on addtocart btn
              this.desktopSelectSizeBtn?.classList.add(this.CLASSES.pointerEventNone);
              this.fixedSelectSizeBtn?.classList.add(this.CLASSES.pointerEventNone);
              setTimeout(() => {
                this.isQuickshop ? null : this.fixedSelectSizeBtn?.classList.remove(this.CLASSES.success);
                if (this.desktopSelectSizeBtn) {
                  this.desktopSelectSizeBtn.classList.remove(this.CLASSES.success);
                }
                if (!this.productIsUniqueSizeFixed) {
                  this.fixedSelectSizeBtn?.classList.add(this.CLASSES.sizeSelection);
                  this.fixedSelectSizeBtn?.classList.remove(this.CLASSES.addToCart);
                }
                if (this.desktopSelectSizeBtn) {
                  if (this.fixedSelectSizeBtn) {
                    this.fixedSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).innerText = this.desktopSelectSizeBtn.dataset.defaultLabel;
                  }
                  this.desktopSelectSizeBtn.classList.add(this.CLASSES.sizeSelection);
                  this.desktopSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).innerText = this.desktopSelectSizeBtn.dataset.defaultLabel;
                  if (!this.productIsUniqueSize) {
                    this.desktopSelectSizeBtn.dataset.selectedProduct = '';
                    // if not uniquesize product, enable all sizes
                    this.$emit(this.$customEvents.SIZES_EVENTS.enableAll);
                  }
                  // remove pointer event rule on addtocart btn
                  this.desktopSelectSizeBtn?.classList.remove(this.CLASSES.pointerEventNone);
                  this.fixedSelectSizeBtn?.classList.remove(this.CLASSES.pointerEventNone);
                }
              }, 3000);
            }
          });
        }
      });
    }
  }
  /**
   * Cleans up the form submit handler when modal closes
   */
  cleanupModalFormHandler(modal) {
    if (modal) {
      // Find the notify me form in the modal content
      const popupForm = modal.contentEl?.querySelector(
        this.SELECTORS.lowStockPopupNotifyMeForm
      );
      // Find the show notify me button in the modal content
      const popupShowFormButton = modal.contentEl?.querySelector(
        this.SELECTORS.lowStockShowNotifyMeForm
      );
      // Find the actions wrapper element in the modal content
      const popupActions = modal.contentEl?.querySelector(
        this.SELECTORS.lowStockPopupActions
      );

      if (popupForm && popupShowFormButton && popupActions) {
        popupShowFormButton.removeEventListener('click', () =>
          this.handleShowFormLowStock(popupForm, popupActions)
        );
      }

      if (popupForm) {
        popupForm.removeEventListener('submit', this.modalFormSubmitHandler);
      }
      // Clear the submit reference
      this.modalFormSubmitHandler = null;
      console.log('Modal form handler cleaned up');
    }
    // Clear the modal reference
    this.lowStockModalInstance = null;
    console.log('Modal instance cleaned up');
  }

  /**
   * Closes the notify me layer on mobile devices.
   * Adds hidden class to both the notify me layer and backdrop elements if they exist.
   */
  closeNotifyMeLayerMobile() {
    this.notifyMeLayer?.classList.add(this.CLASSES.hidden);
    this.notifyMeBackdrop?.classList.add(this.CLASSES.hidden);
    if (isMobile(MobileBreakpoint.Max767)) {
      this.showLiveChatAndLoginPopup();
    }
  }

  /**
   * Adjusts the sizes of UI elements in the cart component for mobile devices.
   *
   * This method handles the following tasks:
   * - Checks if the component has the "pdpFixedCta" data attribute and if the viewport is smaller than 1024px
   * - Calculates and sets the width of the info wrapper based on the window width minus other element widths
   * - Fixes the width of the action button to prevent it from shrinking during loading states
   */
  fixSizes() {

    const isMobile = isBreakpoint(MobileBreakpoint.Max767)
    const isTablet = isBreakpoint(MobileBreakpoint.Max1023) && !isMobile;
    const actionButton = this.actions.querySelector("button");

    if (this.$component.dataset.hasOwnProperty("pdpFixedCta") && isTablet) {

      const infoWrapperWidth = window.innerWidth - this.actions.getBoundingClientRect().width - this.prices.getBoundingClientRect().width;
      this.infoWrapper.style.width = infoWrapperWidth + "px";
      //fix current size, to prevent shrink on loading state
      if (actionButton) {
        actionButton.style.width = actionButton.getBoundingClientRect().width + "px";
      }
    } else if (isMobile) {
      if (actionButton) {
        actionButton.style.width = "100%";
      }
    }
  }

  /**
   * Handles the form submit event in the modal
   * @param {HTMLFormElement} form The form element
   * @param {Object} modal The vex modal instance
   * @param {Event} event The submit event
   */
  handleModalFormSubmit(form, modal, event) {
    // Prevent default form submission
    event.preventDefault();
    // Find the form element in the modal content
    const popupForm = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupNotifyMeForm
    );
    // Find the notify me form input element in the modal content
    const popupFormInput = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupNotifyMeInput
    );
    // Find the notify me form error element in the modal content
    const popupFormError = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupNotifyMeError
    );
    // Find the notify me form submit button element in the modal content
    const popupFormSubmit = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupNotifyMeSubmit
    );
    // Find the notify me success element in the modal content
    const popupFormSuccessElement = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupNotifyMeSuccessWrapper
    );
    // Find the notify me success text element in the modal content
    const popupFormSuccessText = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupNotifyMeSuccessText
    );

    if (popupFormSubmit) {
      popupFormSubmit.disabled = true;
      popupFormSubmit.classList.add(this.CLASSES.loading);
    }

    if (popupFormError) {
      popupFormError.classList.add(this.CLASSES.hidden);
    }

    if (popupFormInput) {
      popupFormInput.classList.remove(this.CLASSES.inputError);
    }

    const formData = new FormData(form);
    const actionUrl = form.action;

    fetch(actionUrl, {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          return response.text().then((responseAsText) => {
            // Handle success
            if (popupForm) {
              popupForm.classList.add(this.CLASSES.disabled);
            }
            if (popupFormSuccessText) {
              popupFormSuccessText.innerHTML = `${responseAsText}`;
            }
            if (popupFormSuccessElement) {
              popupFormSuccessElement.classList.remove(this.CLASSES.disabled);
            }
          });
        } else {
          return response.text().then((responseAsText) => {
            if (popupFormSubmit) {
              popupFormSubmit.disabled = false;
              popupFormSubmit.classList.remove(this.CLASSES.loading);
            }
            if (popupFormError) {
              popupFormError.classList.remove(this.CLASSES.hidden);
              popupFormError.innerHTML = `${responseAsText}`;
            }
            if (popupFormInput) {
              popupFormInput.classList.add(this.CLASSES.inputError);
            }
          });
        }
      })
      .catch((error) => {
        console.error('Form submission error:', error);
      });
  }

  /**
   * Handle click on show notify me button inside low stock popup
   * @param {HTMLFormElement} formTarget The form element
   * @param {HTMLFormElement} actionsTarget The actions wrapper element
   */
  handleShowFormLowStock(formTarget, actionsTarget) {
    formTarget.classList.remove(this.CLASSES.disabled);
    actionsTarget.classList.add(this.CLASSES.disabled);
  }

  /**
   * Hides the "Add to Cart" button from the UI and manages intersection observer cleanup.
   *
   * This method:
   * 1. Adds a hidden class to the desktop Add to Cart element
   * 2. Disconnects any existing intersection observer
   * 3. Starts a new observer (if not in quickshop mode and desktop element exists)
   */
  hideAddToCart() {
    // hide add to cart cta
    this.desktopAddToCartElement?.classList.add(this.CLASSES.hidden);
    // disconnect intersection observer
    this.cleanup && this.cleanup();
    this.cleanup = (this.desktopAddToCartElement && !this.isQuickshop) ? this.startAddToCartObserver() : null;
  }

  /**
   * Hides both the login popup floating button and live chat floating button.
   * - Emits an event to hide the login popup floating icon
   * - Directly hides the live chat floating button by setting its display style to 'none'
   */
  hideLiveChatAndLoginPopup() {
    // hide login popup floating button
    this.$emit(this.$customEvents.LOGIN_POPUP_EVENTS.hideFloatingIcon);
    // hide live chat floating button
    // execute here for now cause I don't know where should be
    const liveChatFloatingBtn = document.querySelector('#embeddedMessagingConversationButton');
    if (liveChatFloatingBtn) liveChatFloatingBtn.style.display = 'none';
  }

  /**
   * Hides the notify me button and related UI elements.
   * If not in quickshop mode and the notify me button exists,
   * it also initializes an intersection observer for the notify me button.
   *
   * The method:
   * 1. Hides the size selection backdrop and layer in the sticky bar
   * 2. Disconnects any existing intersection observer
   * 3. Sets up a new intersection observer for the notify me button if applicable
   */
  hideNotifyMe() {
    // hide size selection in fixed sticky bar
    this.selectSizeBackdrop?.classList.add(this.CLASSES.hidden);
    this.selectSizeLayer?.classList.add(this.CLASSES.hidden);
    // disconnect intersection observer
    this.cleanupNotifyMe && this.cleanupNotifyMe();
    this.cleanupNotifyMe = (this.notifyMeBtn && !this.isQuickshop) ? this.startNotifyMeObserver() : null;
    // reset hidden input value
    // document.querySelector('#productCode').value = "";
  }

  /**
   * Initializes the notify me layer for mobile view.
   * Removes the hidden class from both the notify me layer and backdrop elements,
   * making them visible to the user.
   */
  initNotifyMeLayerMobile() {
    if (this.fixedAddToCartElement.classList.contains(this.CLASSES.show)) {
      if (this.notifyMeMobile) {
        this.notifyMeMobile.classList.remove(this.CLASSES.hidden);
        this.hideLiveChatAndLoginPopup();
        let notifyBtn = this.notifyMeMobile.querySelector(this.SELECTORS.notifyMeBtn);
        if (notifyBtn) notifyBtn.disabled = false;
      }
    }
  }

  /**
   * Fetches the content from the given URL and opens a modal with the received content.
   * @param {string} url The URL to fetch the content from.
   * @param {string} className The CSS class name for the modal
   */
  openModal(url, className = '') {
    const ctx = this;
    // Fetch the content from the given URL
    fetch(url)
      .then((response) => response.text())
      .then((content) => {
        // Open the modal with the received content
        const modal = vex.open({
          unsafeContent: content,
          closeClassName: 'icon-close',
          showCloseButton: true,
          className,
          afterOpen: function () {
            // Setup form event listener after modal content is loaded
            ctx.setupModalFormHandler(this);
          },
          beforeClose: () => {
            // Cleanup form event listener before modal closes
            ctx.cleanupModalFormHandler(this);
            return true; // Allow modal to close
          },
        });
        this.lowStockModalInstance = modal;
      })
      .catch((error) => {
        console.error('Error loading modal content:', error);
      });
  }

  /**
   * Sets the loading state for the 'Select Size' buttons.
   * Adds loading class to buttons, disables them, and hides text and icon elements.
   * Affects both fixed and desktop buttons (if desktop button exists).
   */
  setLoadingState() {

    if (this.desktopSelectSizeBtn) {
      this.desktopSelectSizeBtn.classList.add(this.CLASSES.loading);
      this.desktopSelectSizeBtn.disabled = true;
      this.desktopSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).classList.add(this.CLASSES.hidden);
      this.desktopSelectSizeBtn.querySelector(`.${this.CLASSES.icon}`).classList.add(this.CLASSES.hidden);
    }
    if (this.fixedSelectSizeBtn) {
      this.fixedSelectSizeBtn.classList.add(this.CLASSES.loading);
      this.fixedSelectSizeBtn.disabled = true;
      this.fixedSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).classList.add(this.CLASSES.hidden);
      this.fixedSelectSizeBtn.querySelector(`.${this.CLASSES.icon}`).classList.add(this.CLASSES.hidden);
    }
  }

  /**
   * Sets up the form submit handler for the notify me form inside the modal
   * @param {Object} modal The vex modal instance
   */
  setupModalFormHandler(modal) {
    // Find the notify me form in the modal content
    const popupForm = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupNotifyMeForm
    );
    // Find the show notify me button in the modal content
    const popupShowFormButton = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockShowNotifyMeForm
    );
    // Find the actions wrapper element in the modal content
    const popupActions = modal.contentEl?.querySelector(
      this.SELECTORS.lowStockPopupActions
    );

    if (popupForm && popupShowFormButton && popupActions) {
      popupShowFormButton.addEventListener('click', () =>
        this.handleShowFormLowStock(popupForm, popupActions)
      );
    }

    // Only bind the form event listener if the specific form exists
    if (popupForm) {
      // Store reference to the bound handler for cleanup
      this.modalFormSubmitHandler = this.handleModalFormSubmit.bind(
        this,
        popupForm,
        modal
      );

      // Add event listener to the form
      popupForm.addEventListener('submit', this.modalFormSubmitHandler);

      console.log('Modal form handler attached');
    }
  }

  /**
   * Displays the "Add to Cart" button and initializes intersection observers.
   * - Removes the 'hidden' class from the desktop "Add to Cart" element
   * - Cleans up any existing observers
   * - Sets up new intersection observers for the "Add to Cart" button and "Notify Me" button
   *   if they exist and not in quickshop mode
   */
  showAddToCart() {
    // show add to cart cta
    this.desktopAddToCartElement?.classList.remove(this.CLASSES.hidden);
    // connect intersection observer
    this.cleanup && this.cleanup();
    this.cleanup = (this.desktopAddToCartElement && !this.isQuickshop) ? this.startAddToCartObserver() : null;
    this.cleanupNotifyMe = (this.notifyMeBtn && !this.isQuickshop) ? this.startNotifyMeObserver() : null;
  }

  /**
   * Displays the login popup floating icon and the live chat floating button.
   * Emits a custom event to show the login popup floating icon.
   * Also directly manipulates the DOM to show the live chat floating button if it exists.
   * @emits {Event} this.$customEvents.LOGIN_POPUP_EVENTS.showFloatingIcon - Emits event to show the login popup floating icon
   */
  showLiveChatAndLoginPopup() {
    // show login popup floating button
    this.$emit(this.$customEvents.LOGIN_POPUP_EVENTS.showFloatingIcon);
    // show live chat floating button
    // execute here for now cause I don't know where should be
    const liveChatFloatingBtn = document.querySelector('#embeddedMessagingConversationButton');
    if (liveChatFloatingBtn) liveChatFloatingBtn.style.display = 'block';
  }

  /**
   * Displays the "Notify Me" functionality based on the current state of the cart.
   * If the fixed add-to-cart element is shown, it displays the size selection in the sticky bar.
   * Otherwise, it shows the standard notify me element.
   * Also connects an intersection observer for the notify me button if it exists and not in quickshop mode.
   */
  showNotifyMe() {
    if (this.fixedAddToCartElement.classList.contains(this.CLASSES.show)) {
      // show size selection in fixed sticky bar
      this.selectSizeBackdrop?.classList.remove(this.CLASSES.hidden);
      this.selectSizeLayer?.classList.remove(this.CLASSES.hidden);
    } else {
      // show notify me standard
      this.notifyMe?.classList.remove(this.CLASSES.hidden);
    }
    // connect intersection observer
    this.cleanupNotifyMe = (this.notifyMeBtn && !this.isQuickshop) ? this.startNotifyMeObserver() : null;
  }


  /**
   * Updates the visibility of the fixed cartbar based on the visibility of the
   * select size button and the recommendation engine.
   * If both are not visible, show the fixed cartbar.
   * If one of the two is visible, hide the fixed cartbar.
   */
  updateBarVisibility(isVisible, elementInViewport) {
    if (isVisible && !(elementInViewport)) {
      // show fixed cartbar
      this.fixedAddToCartElement?.classList.add(this.CLASSES.show);
    }
    if (isVisible && elementInViewport) {
      // hide fixed cartbar only if isn't open by zoom component
      if (!this.fixedAddToCartElement?.classList.contains(this.CLASSES.zoom))
        this.fixedAddToCartElement?.classList.remove(this.CLASSES.show);
    }
  };

  /**
   * Creates an IntersectionObserver instance to track the visibility of the fixed
   * select size button and the recommendation engine, and updates the visibility
   * of the fixed cartbar accordingly (Add to cart case).
   * @returns {function} A cleanup function to disconnect the observers
   */
  startAddToCartObserver() {
    let selectSizeIsInViewport = false;
    let isVisible = false;
    let footerIsInViewport = false;
    let recommendationsIsInViewport = false;

    /**
     * Creates an IntersectionObserver instance to track the visibility of the
     * add to cart button on desktop.
     */
    if (this.desktopAddToCartElement) {
      this.selectSizeObserver = new IntersectionObserver((entries) => {
        selectSizeIsInViewport = entries[0].isIntersecting;
        isVisible = !(this.desktopAddToCartElement?.classList.contains(this.CLASSES.hidden));
        this.updateBarVisibility(isVisible, selectSizeIsInViewport || footerIsInViewport || recommendationsIsInViewport);
      }, this.options);
      this.selectSizeObserver.observe(this.desktopAddToCartElement);
    }

    /**
     * Creates an IntersectionObserver instance to track the visibility of the
     * recommendation engine.
     */
    this.footerObserver = new IntersectionObserver((entries) => {
      footerIsInViewport = entries[0].isIntersecting;
      isVisible = !(this.desktopAddToCartElement?.classList.contains(this.CLASSES.hidden));
      this.updateBarVisibility(isVisible, selectSizeIsInViewport || footerIsInViewport || recommendationsIsInViewport);
    }, this.options);

    if (isBreakpoint(MobileBreakpoint.Max1023)) {
      this.footerObserver.observe(this.footerElement);
    }

    /**
     * Creates an IntersectionObserver instance to track the visibility of the
     * recommendation engine.
     */
    this.reccomentdationObserver = new IntersectionObserver((entries) => {
      recommendationsIsInViewport = entries[0].isIntersecting;
      isVisible = !(this.desktopAddToCartElement?.classList.contains(this.CLASSES.hidden));
      this.updateBarVisibility(isVisible, selectSizeIsInViewport || footerIsInViewport || recommendationsIsInViewport);
    }, this.options);

    if (isBreakpoint(MobileBreakpoint.Max1023)) {
      this.reccomentdationObserver.observe(this.recommendationEngineElement);
    }

    let ctx = this;
    return function cleanup() {
      // disconnect the observers when the component is destroyed
      ctx.selectSizeObserver.disconnect();
      ctx.footerObserver.disconnect();
    };
  }

  /**
   * Creates an IntersectionObserver instance to track the visibility of the
   * select size button and the recommendation engine, and updates the visibility
   * of the fixed cartbar accordingly (Notify me case).
   * @returns {function} A cleanup function to disconnect the observers
   */
  startNotifyMeObserver() {
    let selectSizeIsInViewport = false;
    let isVisible = false;
    let footerIsInViewport = false;
    let recommendationsIsInViewport = false;

    /**
     * Creates an IntersectionObserver instance to track the visibility of the
     * select size button on desktop.
     */
    if (this.notifyMe) {
      this.selectSizeNotifyMeObserver = new IntersectionObserver((entries) => {
        selectSizeIsInViewport = entries[0].isIntersecting;
        isVisible = !(this.notifyMe?.classList.contains(this.CLASSES.hidden));
        this.updateBarVisibility(isVisible, selectSizeIsInViewport || footerIsInViewport || recommendationsIsInViewport);
      }, this.options);
      this.selectSizeNotifyMeObserver.observe(this.notifyMe);
    }

    /**
     * Creates an IntersectionObserver instance to track the visibility of the
     * recommendation engine.
     */
    this.footerNotifyMeObserver = new IntersectionObserver((entries) => {
      footerIsInViewport = entries[0].isIntersecting;
      isVisible = !(this.notifyMe?.classList.contains(this.CLASSES.hidden));
      this.updateBarVisibility(isVisible, selectSizeIsInViewport || footerIsInViewport || recommendationsIsInViewport);
    }, this.options);

    if (this.footerElement) {
      this.footerNotifyMeObserver.observe(this.footerElement);
    }


    /**
     * Creates an IntersectionObserver instance to track the visibility of the
     * recommendation engine.
     */
    this.reccomentdationObserver = new IntersectionObserver((entries) => {
      recommendationsIsInViewport = entries[0].isIntersecting;
      isVisible = !(this.notifyMe?.classList.contains(this.CLASSES.hidden));
      this.updateBarVisibility(isVisible, selectSizeIsInViewport || footerIsInViewport || recommendationsIsInViewport);
    }, this.options);

    if (this.recommendationEngineElement) {
      this.reccomentdationObserver.observe(this.recommendationEngineElement);
    }

    let ctx = this;
    return function cleanupNotifyMe() {
      // disconnect the observers when the component is destroyed
      ctx.selectSizeNotifyMeObserver.disconnect();
      ctx.footerNotifyMeObserver.disconnect();
      ctx.reccomentdationObserver.disconnect();
    };
  }

  /**
   * Removes the loading state from the size selection buttons.
   * This method:
   * - Removes the loading class from the fixed size selection button
   * - If a desktop size selection button exists:
   *   - Removes the loading class
   *   - Enables the button
   *   - Shows the text and icon elements
   * - Enables the fixed size selection button
   * - Shows the text and icon elements of the fixed size selection button
   */
  unsetLoadingState() {

    if (this.desktopSelectSizeBtn) {
      this.desktopSelectSizeBtn.classList.remove(this.CLASSES.loading);
      this.desktopSelectSizeBtn.disabled = false;
      this.desktopSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).classList.remove(this.CLASSES.hidden);
      this.desktopSelectSizeBtn.querySelector(`.${this.CLASSES.icon}`).classList.remove(this.CLASSES.hidden);
    }

    if (this.fixedSelectSizeBtn) {
      this.fixedSelectSizeBtn.classList.remove(this.CLASSES.loading);
      this.fixedSelectSizeBtn.disabled = false;
      this.fixedSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).classList.remove(this.CLASSES.hidden);
      this.fixedSelectSizeBtn.querySelector(`.${this.CLASSES.icon}`).classList.remove(this.CLASSES.hidden);
    }
  }

  /**
   * Binds all events to the component.
   */
  bindEvents() {
    this.cleanup = (this.desktopAddToCartElement && !this.isQuickshop) ? this.startAddToCartObserver() : null;
    this.cleanupNotifyMe = (this.notifyMeBtn && !this.isQuickshop) ? this.startNotifyMeObserver() : null;

    // Bind event to the fixed add to cart button
    this.fixedSelectSizeBtn?.addEventListener('click', () => {
      if (this.fixedSelectSizeBtn.classList.contains(this.CLASSES.addToCart)) {
        // Add to cart button was clicked
        this.addToCart(
          this.desktopSelectSizeBtn.dataset.selectedProduct,
          this.fixedSelectSizeBtn.dataset.exceededCartQty,
          this.fixedSelectSizeBtn.dataset.lowstockCartQty,
          true,
          this.fixedSelectSizeBtn
        );
      } else {
        // Size selection button was clicked
        this.selectSizeBackdrop?.classList.remove(this.CLASSES.hidden);
        this.selectSizeLayer?.classList.remove(this.CLASSES.hidden);
        if (isMobile(MobileBreakpoint.Max767)) {
          this.hideLiveChatAndLoginPopup();
        }
      }
    });

    // Bind event to the close button of the size selection modal
    this.selectSizeLayerCloseBtnList?.forEach(closeBtn => {
      closeBtn.addEventListener('click', () => {
        this.selectSizeBackdrop?.classList.add(this.CLASSES.hidden);
        this.selectSizeLayer?.classList.add(this.CLASSES.hidden);
        if (!this.productIsUniqueSizeFixed) {
          this.fixedSelectSizeBtn.classList.add(this.CLASSES.sizeSelection);
          this.fixedSelectSizeBtn.classList.remove(this.CLASSES.addToCart);
        }
        if (isMobile(MobileBreakpoint.Max767)) {
          this.showLiveChatAndLoginPopup();
        }
      });
    })

    // Bind events to each size selection button
    this.sizes?.forEach(size => {
      size.addEventListener('click', () => {
        const unavailable = Boolean(size.dataset.unavailable);
        if (!unavailable) {
          // add to cart
          const sizeCode = size.dataset.productCode;
          const exceededQtyUrl = this.fixedSelectSizeBtn?.dataset.exceededCartQty;
          const lowStockUrl = this.fixedSelectSizeBtn?.dataset.lowstockCartQty;
          this.addToCart(
            sizeCode,
            exceededQtyUrl,
            lowStockUrl,
            true,
            this.fixedSelectSizeBtn
          );
        }
      });
    });

    // Bind event to the desktop add to cart button
    this.desktopSelectSizeBtn?.addEventListener('click', (event) => {
      if (this.desktopSelectSizeBtn.classList.contains(this.CLASSES.addToCart)) {
        let target = event.target;
        if (target.nodeName !== 'BUTTON') {
          target = target.closest('button');
        }
        // Add to cart button was clicked
        this.addToCart(
          this.desktopSelectSizeBtn.dataset.selectedProduct,
          this.desktopSelectSizeBtn.dataset.exceededCartQty,
          this.desktopSelectSizeBtn.dataset.lowstockCartQty,
          true,
          this.desktopSelectSizeBtn
        );
      } else {
        // Size selection button was clicked
        // show fixed cartbar
        this.fixedAddToCartElement?.classList.add(this.CLASSES.show);
        this.selectSizeBackdrop?.classList.remove(this.CLASSES.hidden);
        this.selectSizeLayer?.classList.remove(this.CLASSES.hidden);
        if (isMobile(MobileBreakpoint.Max767)) {
          this.hideLiveChatAndLoginPopup();
        }
      }
    });

    // Bind event to the global size changed event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({payload}) => {
      if (this.desktopSelectSizeBtn && !payload.unavailable && payload.productCode && payload.baseProductCode === this.productCode) {

        if (payload.productCode !== this.desktopSelectSizeBtn.dataset.productCode && payload.baseProductCode !== this.desktopSelectSizeBtn.dataset.baseProduct) {
          this.desktopSelectSizeBtn.dataset.selectedProduct = payload.productCode;
        }

        // Update the fixed add to cart button
        if (!this.isQuickshop && this.fixedSelectSizeBtn) {
          this.fixedSelectSizeBtn.classList.remove(this.CLASSES.sizeSelection);
          this.fixedSelectSizeBtn.classList.add(this.CLASSES.addToCart);
          this.fixedSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).innerText = this.desktopSelectSizeBtn.dataset.addtocartLabel;
        }
        // Update the desktop add to cart button
        this.desktopSelectSizeBtn.classList.remove(this.CLASSES.sizeSelection);
        this.desktopSelectSizeBtn.classList.add(this.CLASSES.addToCart);
        this.desktopSelectSizeBtn.querySelector(`.${this.CLASSES.text}`).innerText = this.desktopSelectSizeBtn.dataset.addtocartLabel;

        // Update addToCart mobile notification size's value
        this.itemAdded = document.querySelector(`[data-pdp-item-added="${this.productCode}"]`);
        this.itemAddedSize = this.itemAdded?.querySelector(this.SELECTORS.itemAddedSize);
        if (this.itemAddedSize) this.itemAddedSize.innerHTML = payload.sizeSelected || '';

        this.errorsBox?.classList.add(this.CLASSES.hidden);
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {


      // if we are in mobile breakpoint, init notify me for floating bar
      if (payload.productCode && payload.productCode === this.productCode) {
        this.hideAddToCart();

        if (!this.isQuickshop) {
          this.selectSizeBackdrop?.classList.remove(this.CLASSES.hidden);
          this.selectSizeLayer?.classList.remove(this.CLASSES.hidden);
          if (isBreakpoint(MobileBreakpoint.Max1023)) {
            this.hideLiveChatAndLoginPopup();
          }
        }
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeclose, ({event, payload}) => {
      if (payload.productCode && payload.productCode === this.productCode) {
        this.showAddToCart();
        this.hideNotifyMe();
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymesuccess, ({event, payload}) => {
      if (payload.productCode && payload.productCode === this.productCode && !payload.completeLook) {
        this.showAddToCart();
        this.hideNotifyMe();
        if (isMobile(MobileBreakpoint.Max767)) {
          this.showLiveChatAndLoginPopup();
        }
      }
    });

    // Bind events to the global open and close zoom events
    this.$on(this.$customEvents.PDP_LAYER_EVENTS.openZoom, () => {
      this.fixedAddToCartElement.classList.add(this.CLASSES.show);
      this.fixedAddToCartElement.classList.add(this.CLASSES.zoom);
    });

    this.$on(this.$customEvents.PDP_LAYER_EVENTS.closeZoom, () => {
      this.fixedAddToCartElement.classList.remove(this.CLASSES.show);
      this.fixedAddToCartElement.classList.remove(this.CLASSES.zoom);
    });

    this.$on(this.$customEvents.PDP_LAYER_EVENTS.closeZoomMobile, () => {
      // disconnect intersection observer
      this.cleanup && this.cleanup();
      this.cleanupNotifyMe && this.cleanupNotifyMe();
      // connect intersection observer
      this.cleanup = this.desktopAddToCartElement ? this.startAddToCartObserver() : null;
      this.cleanupNotifyMe = this.notifyMeBtn ? this.startNotifyMeObserver() : null;
    });

    this.$on(this.$customEvents.SCREEN_EVENTS.resize, () => {
      this.fixSizes();
    });

    // if we are in mobile breakpoint, init notify me for floating bar
    this.notifyMeBtnFixed?.addEventListener('click', (e) => {
      if (isMobile(MobileBreakpoint.Max767)) {
        e.preventDefault();
        this.initNotifyMeLayerMobile();
      }
    });

    // close zoom layer in mobile
    this.notifyMeLayerCloseBtn?.addEventListener('click', () => {
      this.closeNotifyMeLayerMobile();
    });

    // when notify me is done, if we are in mobile breakpoint, init notify me for floating bar
    this.$on(this.$customEvents.NOTIFY_ME_STATE.sent, () => {
      if (isMobile(MobileBreakpoint.Max767)) {
        this.closeNotifyMeLayerMobile();
      }
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    this.fixSizes();
  }
}
